import * as React from "react";
import { Context, CartSlider, Cart } from "@grandvisionhq/carts-v2";
import { toast } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { WithUserData } from "@grandvisionhq/my-account";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { pushCheckoutEventToDataLayer } from "../../data-layer.js";
import { Header } from "../../modules/Header/modules/Header/Header.js";
/* empty css                                   */
import { LoggedInExpressCheckoutProvider } from "../context/LoginExpressCheckout/context/Provider.js";
import { ShippingMethodsContainer } from "../modules/shipping/LoginExpressCheckout/modules/shipping/ShippingMethodsContainer.js";
import { UserDetails } from "../modules/UserDetails/LoginExpressCheckout/modules/UserDetails/UserDetails.js";
import { ConsentsAndOptInsContainer } from "../modules/ConsentAndOptins/LoginExpressCheckout/modules/ConsentAndOptins/ConsentsAndOptinsContainer.js";
import { PaymentsContainer } from "../modules/Payments/LoginExpressCheckout/modules/Payments/PaymentsContainer.js";
const LoginExpressCheckoutContainer = ({
  backButton,
  title,
  shippingMethodsAsides,
  selfUrl
}) => {
  const { cart, loading, called } = Context.useCart();
  const { onClick: redirectToCartPage } = useLink({ route: "cart.overview" }, { replace: true }) || {};
  const [, setPaymentStatus] = React.useState("");
  const handleCartError = React.useCallback(() => {
    if (called && !loading && !cart) {
      console.error("Cart is empty");
      redirectToCartPage?.();
    } else if (cart?.checkoutState == "Finalized") {
      console.error("Cart is not in active state");
      toast.failed("cart.errors.cartNotInActiveState");
      redirectToCartPage?.();
    }
  }, [called, cart, loading, redirectToCartPage]);
  const intl = useIntl();
  const isCheckoutEventFired = React.useRef(false);
  React.useEffect(() => {
    handleCartError();
  }, [loading, cart]);
  React.useEffect(() => {
    if (!loading && cart && !isCheckoutEventFired.current) {
      pushCheckoutEventToDataLayer(cart, intl.currency, "login_checkout");
      isCheckoutEventFired.current = true;
    }
  }, [loading, cart, intl.currency]);
  return /* @__PURE__ */ React.createElement("div", { className: "login-express-checkout" }, /* @__PURE__ */ React.createElement(Header, { title, backButton }), /* @__PURE__ */ React.createElement("section", { className: "login-express-checkout__inner" }, /* @__PURE__ */ React.createElement(CartSlider, null, /* @__PURE__ */ React.createElement(Cart, null)), /* @__PURE__ */ React.createElement(LoggedInExpressCheckoutProvider, null, /* @__PURE__ */ React.createElement("section", { className: "login-express-checkout__shipping" }, /* @__PURE__ */ React.createElement(ShippingMethodsContainer, { shippingMethodsAsides })), /* @__PURE__ */ React.createElement("section", { className: "login-express-checkout__user-details" }, /* @__PURE__ */ React.createElement(UserDetails, null)), /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(ConsentsAndOptInsContainer, null)), /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(PaymentsContainer, { selfUrl, updateCheckoutStatus: setPaymentStatus })))));
};
const ExpressLoginCheckoutContainerWithUserData = WithUserData(LoginExpressCheckoutContainer);
const ExpressLoginCheckoutContainerWithMyAccount = ({
  ...props
}) => {
  const { isMyAccountEnabled } = useFeatureToggles();
  return /* @__PURE__ */ React.createElement(ExpressLoginCheckoutContainerWithUserData, { ...props, isMyAccountEnabled });
};
export {
  ExpressLoginCheckoutContainerWithMyAccount as default
};
//# sourceMappingURL=LoginExpressCheckoutContainer.js.map
